import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'remixicon/fonts/remixicon.css';

import './assets/css/remixicon.css'; 
import "./assets/css/style.css"
import { HelmetProvider } from "react-helmet-async";

// root render లో:

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <HelmetProvider>
  <App />
</HelmetProvider>
  </React.StrictMode>
);

